import React from 'react';
import classNames from 'classnames';

import { CalendarIcon } from 'components/library';
import { FormattedDate, FormattedTime, LocaleString } from '@biw/intl';
import LastDayLeft from './last-day-left';
import { ProgramModel } from '@biw/contests-core/lib/dux/programs';

interface Props {
    program: ProgramModel;
}

export const DaysLeft = ( { program }: Props ) => {
    let calendarLabel;

    if (program.isGoalSelection) {
        calendarLabel = program.hasGoalSelectedAndInGoalSelectionPeriod ?
            'goalSelection.toChangeGoal' :
            'goalSelection.toSelectGoal';
    } else if (!program.programHasStarted) {
        calendarLabel = 'progress.daysToProgramStartLabel';
    } else {
        calendarLabel = 'progress.daysToEarnLabel';
    }

    const daysLeft = program.daysLeft;
    const daysLeftClasses = classNames( 'days-label', `days-left-${daysLeft}`, { warning: daysLeft < 2 });
    const descriptionClasses = classNames( { description: true, warning: daysLeft < 2 } );

    const containerClasses = classNames( 'goal-select-days-left', { 'in-progress': program.hasProgress } );
    return (
        <aside className={containerClasses}>
            <section className="days-left-container">
                <span className="calendar-icon"><CalendarIcon /></span>
                <div className="days-left">
                    { daysLeft > 1 ?
                        <span>
                            <span className={daysLeftClasses}>{daysLeft}</span>
                            &nbsp;
                            <span className="days-left-label description">
                                <LocaleString className={daysLeftClasses} code="goalSelection.headerDaysLeft" />
                                <LocaleString className={descriptionClasses} data-sel="goal-selection-calendar-label" code={calendarLabel} />
                            </span>
                        </span>
                    :
                        <span>
                            <span className={daysLeftClasses}>
                                { program.isObjectives ?
                                    <LocaleString data-sel="goal-selection-last-day" code="programInfoHeader.objective.lastDay" />
                                :
                                    <LocaleString data-sel="goal-selection-last-day" code="programInfoHeader.lastDay" />
                                }
                            </span>
                            <LastDayLeft program={program} calendarLabel={calendarLabel} />
                            &nbsp;<span className="to-select-label">
                                { program.isObjectives ?
                                    <LocaleString code="programInfoHeader.objective.starts" />
                                :
                                    <LocaleString code="programInfoHeader.closes" />
                                }
                                &nbsp;
                                <span data-sel="goal-selection-closing-time" className="to-select-label-date">
                                    <FormattedDate value={program.lastDayLeftDate} />
                                    &nbsp;&#64;&nbsp;
                                    <FormattedTime value={program.lastDayLeftDate} />
                                </span>
                            </span>
                        </span>
                    }
                </div>
            </section>
        </aside>
    );
};

export default DaysLeft;
